// Estados do vínculo, na ordem do ciclo de vida. `sem_vinculo` é a tradução que o
// backend faz de "este tenant não tem conexao_caixa_vinculo_id nas Options".
export const ESTADOS_VINCULO = [
  "sem_vinculo",
  "aguardando_agente",
  "aguardando_login",
  "aguardando_perfil",
  "ativo",
  "revogado",
];

// `acao` diz ao componente qual botão oferecer junto da mensagem. Nunca é adivinhado:
// código sem entrada aqui cai no ramo "desconhecido", que mostra o código cru.
export const MENSAGENS_ERRO_VINCULO = {
  agente_offline: {
    mensagem: "Sem comunicação com o computador da lotérica.",
    acao: "verificar",
  },
  agente_nao_logado: {
    mensagem: "Acesso à Caixa pendente. Conclua na janela aberta no computador da lotérica.",
    acao: "verificar",
  },
  perfil_indisponivel: {
    mensagem: "Este perfil não está disponível. Escolha outro da lista.",
    acao: "recarregar_perfis",
  },
  perfil_imutavel: {
    mensagem: "O perfil desta conexão não pode ser alterado.",
    acao: "desconectar",
  },
  perfil_desconhecido: {
    mensagem: "Este perfil não está mais na lista. Atualize e tente de novo.",
    acao: "recarregar_perfis",
  },
  vinculo_nao_ativo: {
    mensagem: "Esta conexão ainda não está pronta. Conclua a configuração antes.",
    acao: "verificar",
  },
  codigo_invalido: {
    mensagem: "Código inválido, expirado ou já utilizado. Peça um código novo.",
    acao: null,
  },
  nao_encontrado: {
    mensagem: "Esta conexão não existe mais. Refaça a configuração.",
    acao: "desconectar",
  },
  falha_comunicacao: {
    mensagem: "Falha de comunicação. Verifique a internet e tente novamente.",
    acao: "verificar",
  },
};

function lerCodigo(data) {
  if (!data || typeof data !== "object") return null;
  // `data` é o envelope da API ({success, message, data, errors}); o backend põe o
  // código em data.codigo, então daqui é data.data.codigo. Conciliado 2026-07-26
  // contra o plano do agil-online — grafia única, sem tolerância a variantes.
  if (data.data && typeof data.data.codigo === "string") return data.data.codigo;
  return null;
}

function lerMensagemBackend(data) {
  if (!data || typeof data !== "object") return "";
  if (typeof data.message === "string") return data.message;
  if (data.data && typeof data.data.message === "string") return data.data.message;
  return "";
}

/**
 * Converte a resposta de erro do axios-auth (`{ error }`) em erro humanizado.
 * Nunca devolve null e nunca engole um código que não conhece.
 *
 * @param {object} res resposta do interceptor: `{ error: { response: { status, data } } }`
 * @return {{codigo: string, mensagem: string, acao: (string|null), status: (number|null)}}
 */
export function extrairErroVinculo(res) {
  const erroAxios = res && res.error;
  const resposta = erroAxios && erroAxios.response;
  const data = resposta && resposta.data;
  // Status HTTP cru. O orquestrador usa só para distinguir 403 (sem permissão) do
  // resto — a UI nunca mostra este número ao cliente.
  const status = (resposta && typeof resposta.status === "number") ? resposta.status : null;

  const codigo = lerCodigo(data);

  if (!codigo) {
    const mensagemBackend = lerMensagemBackend(data);
    if (mensagemBackend) {
      return { codigo: "desconhecido", mensagem: mensagemBackend, acao: null, status };
    }
    return Object.assign(
      { codigo: "falha_comunicacao", status },
      MENSAGENS_ERRO_VINCULO.falha_comunicacao
    );
  }

  const conhecido = MENSAGENS_ERRO_VINCULO[codigo];
  if (conhecido) {
    return { codigo, mensagem: conhecido.mensagem, acao: conhecido.acao, status };
  }

  const mensagemBackend = lerMensagemBackend(data) || "Erro não previsto pelo sistema.";
  return {
    codigo,
    mensagem: `${mensagemBackend} (código: ${codigo})`,
    acao: null,
    status,
  };
}
